import { type CardIdType } from '@/defs/card'
import { useCard } from '@/hooks/useCard'
import { useReduxSelector } from '@/store/hooks'
import { selectors } from '@/store/selectors'

export const useCardArtChooser = (cardId?: CardIdType) => {
  const { card } = useCard({ cardId })
  const isEnabled = useReduxSelector(selectors.patreonTier) === 'rare'
  const selected = useReduxSelector((s) => selectors.alternateArt(s, cardId))

  const uniqueArtwork = card?.uniqueArtwork
  const hasOptions = !!uniqueArtwork && uniqueArtwork.length > 1

  return { hasOptions, isEnabled, selected, uniqueArtwork }
}
